import { atom, useAtom } from "jotai";
import { CashDroOperationType } from "../utils/cashDro";

export type CashDroPaymentPhase =
  /** Waiting for the terminal to accept the operation. */
  | "starting"
  /** The customer is paying at (or, for a refund, being paid by) the terminal. */
  | "collecting"
  | "cancelling"
  /** The money has moved, the order / payment / refund is being saved. */
  | "saving"
  /** The money has moved but saving failed - can be retried without moving money again. */
  | "saveFailed"
  /** The terminal finished a sale with less than the amount due. */
  | "partial"
  | "failed";

export interface CashDroPaymentState {
  /** SALE collects cash from the customer, PAYMENT pays a refund out to them. */
  type: CashDroOperationType;
  phase: CashDroPaymentPhase;
  amount: number;
  operationId?: string;
  /** In cents, as reported by CashDro. */
  totalIn: number;
  totalOut: number;
  error?: string;
  /** Books what the terminal did (posts the order, pays the session, books the refund, ...). */
  onPaid: () => Promise<unknown>;
}

const cashDroPaymentAtom = atom(null as CashDroPaymentState | null);

const useCashDroPaymentState = () => useAtom(cashDroPaymentAtom);

export default useCashDroPaymentState;
